module.exports = __webpack_public_path__ + "img/1120384949.ff7020b7.png";